import React from "react";

interface IconProps {
  fill: string;
  title: string;
}

const ElevatorGray: React.FC<IconProps> = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" fill={props.fill}>
    <title>{props.title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="elevator_gray">
          <path d="M25.65,91.76a7.59,7.59,0,0,1-7.55-7.61V43.85a7.59,7.59,0,0,1,7.55-7.61Z" />
          <rect x="25.63" y="84.24" width="45.18" height="7.53" />
          <path d="M70.78,91.76V36.24a7.58,7.58,0,0,1,7.55,7.61v40.3A7.58,7.58,0,0,1,70.78,91.76Z" />
          <rect x="31.39" y="36.24" width="33.65" height="7.53" />
          <path d="M71.84,20l-4.26-4.23,0,0,4.23-4.27A6,6,0,0,1,71.84,20Z" />
          <path d="M59.8,30.89a3,3,0,0,1-3-3L56.63,5.24a3,3,0,0,1,6,0l.12,15.48,4.83-4.88A3,3,0,1,1,71.84,20L61.93,30A3,3,0,0,1,59.8,30.89Z" />
          <path d="M24.6,22.05a6,6,0,0,1,0-8.5l4.26,4.22,0,0Z" />
          <path d="M36.8,31.35a3,3,0,0,1-3-3L33.68,12.9l-4.83,4.87a3,3,0,1,1-4.26-4.22l9.91-10a3,3,0,0,1,5.13,2.09l.17,22.68a3,3,0,0,1-3,3Z" />
          <polygon points="51.73 25.2 44.73 18.2 44.73 9.61 51.73 16.61 51.73 25.2" />
        </g>
      </g>
    </g>
  </svg>
);

export default ElevatorGray;
